module.exports = __webpack_public_path__ + "img/bg-header-before-sti-dest.2c73f221.svg";